export const createDate = (dateString: string): Date => {
  return new Date(dateString);
};
export const formatDate = (dateString: string): string => {
  if (!dateString.endsWith('Z')) {
    dateString = dateString + 'Z';
  }
  const date = createDate(dateString); // Creates a date object in local time

  // Extract local components
  const day = String(date.getDate()).padStart(2, '0');
  const month = date.toLocaleString('default', { month: 'short' });
  const year = date.getFullYear();
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');

  // Format the date and time
  const formattedDate = `${day}-${month}-${year} ${hours}:${minutes}`;
  return formattedDate;
};
export const isExpired = (dateString: string): boolean => {
  if (!dateString.endsWith('Z')) {
    dateString = dateString + 'Z';
  }
  const date = createDate(dateString); // Creates a date object in local time

  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - date.getTime(); // Difference in milliseconds
  const oneDayInMillis = 1 * 24 * 60 * 60 * 1000; // Milliseconds in one day

  return timeDifference > oneDayInMillis;
};

export const isPast = (dateString: string): boolean => {
  if (!dateString.endsWith('Z')) {
    dateString = dateString + 'Z';
  }
  const date = createDate(dateString); // Creates a date object in local time

  const currentDate = new Date();
  const timeDifference = currentDate.getTime() - date.getTime(); // Difference in milliseconds

  return timeDifference > 0;
};
